/*
Screws
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Screws'
const id = 'XFIyXym7VTjayPLG1hN9'

export default {
  name,
  id,
  filters,
  headers,
  form
}
